import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import BccSearchTerms from './components/BccSearchTerms';

const BccSearchTermsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Brand Category Competition - Search Terms</h3>
      </Col>
    </Row>
    <Row>
      <BccSearchTerms />
    </Row>
  </Container>
);

export default BccSearchTermsPage;
